module.exports = __webpack_public_path__ + "img/commandpost_parked.4a188308.svg";